"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridItem = void 0;

var _styles = require("./styles");

var _ImageCarousel = require("../../atoms/ImageCarousel");

var _Status = require("../../atoms/Status");

var _PercentTag = require("../../atoms/PercentTag");

var _ButtonV = require("../../atoms/ButtonV2");

var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _RatingStars = require("../../atoms/RatingStars");

var _CheckBox = require("../../atoms/CheckBox");

var _highPriority = _interopRequireDefault(require("../../../assets/images/flags/highPriority.svg"));

var _lowPriority = _interopRequireDefault(require("../../../assets/images/flags/lowPriority.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var GridItem = function GridItem(_ref) {
  var _ref$gridElement = _ref.gridElement,
      gridElement = _ref$gridElement === void 0 ? {} : _ref$gridElement,
      product = _ref.product,
      id = _ref.id,
      _ref$isMerchans = _ref.isMerchans,
      isMerchans = _ref$isMerchans === void 0 ? false : _ref$isMerchans,
      chkOnChange = _ref.chkOnChange,
      onGridClick = _ref.onGridClick,
      chkChecked = _ref.chkChecked,
      index = _ref.index;
  var images = gridElement.images,
      info = gridElement.info,
      status = gridElement.status,
      catalogs = gridElement.catalogs,
      observations = gridElement.observations;

  var getSrvName = function getSrvName(srv) {
    switch (srv) {
      case "datasheet":
        return "F.T.";

      case "description":
        return "D.C.";

      case "images":
        return "IMG";

      case "general":
        return "S.G.";

      default:
        return srv;
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    onClick: function onClick(e) {
      return onGridClick && onGridClick(e, product, index);
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "chk-container",
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.CheckBox, {
        id: "chk-" + id,
        name: "chk-" + id,
        className: "chk-absolute",
        onChange: function onChange(e) {
          return chkOnChange && chkOnChange(e, product);
        },
        defaultChecked: chkChecked && chkChecked(product)
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageCarousel.ImageCarousel, {
      imageArray: images
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "data-body",
      children: info === null || info === void 0 ? void 0 : info.map(function (item, i) {
        return i === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
          children: item.value
        }, i) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: item.value
        }, i);
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "status-slider",
      children: [product.observations && /*#__PURE__*/(0, _jsxRuntime.jsx)("figure", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          style: {
            height: 15,
            width: 15,
            objectFit: "scale-down"
          },
          src: product.observations !== null && product.observations !== "" ? _highPriority.default : _lowPriority.default,
          alt: ""
        })
      }), product.reviewState && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StateReview, {
        backgroundColor: "".concat(product.reviewState),
        children: product.reviewState
      }), status === null || status === void 0 ? void 0 : status.map(function (_ref2) {
        var title = _ref2.title,
            value = _ref2.value,
            percent = _ref2.percent;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "status-element",
          children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "srv-name",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              children: getSrvName(title)
            })
          }), value && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Status.Status, {
            statusType: value
          }), percent && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PercentTag.PercentTag, {
            percent: percent,
            progressBarType: value
          })]
        });
      })]
    }), isMerchans ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "cart-and-raiting",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        borderType: "circle",
        type: "whiteS2",
        icon: _freeRegularSvgIcons.faStar,
        size: 10,
        className: "star-button"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        borderType: "circle",
        type: "whiteS2",
        icon: _freeSolidSvgIcons.faCartPlus,
        size: 10,
        className: "star-button"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
        borderType: "circle",
        type: "whiteS2",
        icon: _freeSolidSvgIcons.faCartPlus,
        size: 10,
        className: "star-button"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RatingStars.RatingStars, {
        ratingValue: 4
      })]
    }) : catalogs && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "retailers-and-user",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "retailers-container",
        children: catalogs.leftSide
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "users-container",
        children: catalogs.rightSide
      })]
    })]
  });
};

exports.GridItem = GridItem;